@if (outroService.outroReason == outroService.OUTRO_REASON_TIMEISUP) {
<h2>Ihre Prüfungszeit ist abgelaufen</h2>
<p>
  Ihre bisherigen Antworten wurden automatisch gespeichert und an das
  PKV Institut übermittelt.
</p>

<h3>Wie geht es nun weiter?</h3>
<p>
  Die Korrektur Ihrer Fallaufgabe dauert etwa sechs Wochen.<br>
  Sobald beide Fallaufgaben bewertet wurden, können Sie Ihre Endnote im
  Lerncampus in Ihrem persönlichen Profil einsehen.<br>
  Weitere Informationen zur Abschlussprüfung finden Sie in der
  Prüfungsordnung Ihres Fernlehrgangs im Lerncampus.
</p>

<h3>Bei Rückfragen</h3>
<p>
  Ihre Teilnehmerbetreuung steht Ihnen gerne zur Verfügung.<br>
  Sie erreichen diese über den Lerncampus, per E-Mail oder telefonisch.
</p>
<p><em>Sie sind fertig und können das Fenster schließen.</em></p>
}

@if (outroService.outroReason == outroService.OUTRO_REASON_USERSUBMIT) {
<div [innerHTML]="this.userSubmitOutroText"></div>
}